import { LayoutBreakpointsConfig } from '../components-shared/LayoutSizeProvider/types';

export const PARENT_APP_DEF_ID = '9142e27e-2e30-4948-ad8f-7e128939efc4';
export const APP_DEF_ID = '9a5d83fd-8570-482e-81ab-cfa88942ee60';
export const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';

export const LAYOUT_BREAKPOINTS_START: LayoutBreakpointsConfig = {
  // mobile
  XS: 320,
  S: 500,
  // desktop & tablet
  M: 980,
  L: 1120,
};

export enum AppPage {
  FulfillmentMethod,
  ItemModal,
  OnlineOrders,
  OrderError,
  OrderTrackingPage,
}

export const PageTitle: Record<AppPage, string> = {
  [AppPage.FulfillmentMethod]: 'Fulfillment Method',
  [AppPage.ItemModal]: 'Item Details',
  [AppPage.OnlineOrders]: 'Online Orders',
  [AppPage.OrderError]: 'Order Error',
  [AppPage.OrderTrackingPage]: 'Order Tracking Page',
};

export const AppPageComponentId: Record<AppPage, string> = {
  [AppPage.FulfillmentMethod]: '78b637a1-ad0d-4497-83bb-4b7b96b62f9a',
  [AppPage.ItemModal]: 'dd7f92b8-40c7-4737-be83-949c3cbff985',
  [AppPage.OnlineOrders]: '75c72cda-5a3d-4e45-b3a8-72fa06d3aeaf',
  [AppPage.OrderError]: 'e976ed67-5e28-4f83-af11-50c6e8a99d45',
  [AppPage.OrderTrackingPage]: '771d3aee-6d61-4c9b-9669-cf258abb894f',
};

export enum TransactionNames {
  widgetLoad = 'widget-load',
  pageLoad = 'page-load',
  getOrder = 'get-order',
  addToCart = 'add-to-cart',
  fetchOperations = 'fetch-operations',
  fetchMenus = 'fetch-menus',
  fetchItems = 'fetch-items',
  fetchDiscountRules = 'fetch-discount-rules',
  fetchFulfillmentMethods = 'fetch-fulfillment-methods',
  fetchTimeSlots = 'fetch-time-slots',
  fetchTimeSlotsByOperation = 'fetch-time-slots-by-operation',
  fetchPremiumStatus = 'fetch-premium-status',
  fetchCoverImage = 'fetch-cover-image',
  loadInitialTimeSlots = 'load-initial-time-slots',
  loadTimeSlotsForDate = 'load-time-slots-for-date',
}

export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_LOCALE = 'en';
export const DEFAULT_TIMEZONE = 'America/New_York';

export const MAX_ITEMS_BATCH_SIZE = 500;

export const DEFAULT_FONT_SIZE_RANGE = { fontMinSize: 6, fontMaxSize: 100 };

export const OOI_OLO_PAGE_ID_PREFIX = 'Online Orders';

export const MENUS_DASHBOARD_URL = '/wix-restaurants-menus-new';
export const OLO_SETTINGS_DASHBOARD_URL = '/olo-settings';

export const LIGHTBOX_IDS = {
  itemModal: 'itemModal',
  fulfillmentMethod: 'dispatchModal',
  orderError: 'errorModal',
};

export const LIGHTBOX_QUERY_PARAM_KEY = 'lightboxOnScreen';

export const MENU_QUERY_PARAMS = {
  itemId: 'itemId',
  sectionId: 'sectionId',
  menuId: 'menuId',
} as const;

export const FULFILLMENT_QUERY_PARAMS = {
  dispatchType: 'dispatchType',
} as const;

// TODO: confirm the correct unique name for restaurant online ordering premium
export const PREMIUM_UNIQUE_NAME = 'restaurants_table_reservations';

// Ceiling for a request the settings panel holds its tab rail on
export const SETTINGS_DATA_TIMEOUT_MS = 5000;

export const WIX_ADS_ELEMENT_ID = 'WIX_ADS';
